import { render, staticRenderFns } from "./ReportGlobalFilters.vue?vue&type=template&id=6b0f29a2"
import script from "./ReportGlobalFilters.vue?vue&type=script&lang=js"
export * from "./ReportGlobalFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports